// extracted by mini-css-extract-plugin
export default {"page":"XwSIT6","pageNF":"vvhQfD","pageNf":"vvhQfD"};